module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/status-report/status-report.component.css
// module id = ./src/app/status-report/status-report.component.css
// module chunks = main